export const APICODE = {
  /**
   * 成功状态码  success
   */
  SUCCESS: 200,
  /**
   * 登录失效状态码  未登录
   */
  NEED_LOGIN: 800
}
